import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';
import ListItemInfos from '../../../components/ListItem/Infos';
import DownloadManagerUtils from '../../../utils/downloadManager';
import { Api } from '../../../typings/api';

interface ListItemInfosOwnProps {
	driveItemId?: number;
}

const mapStateToProps = (state: StoreState, ownProps: ListItemInfosOwnProps) => {
	const { downloadManager, driveList } = state;
	const { driveItemId } = ownProps;

	let isUpToDate = false;
	let isUpdatable = false;
	let proposalStats: Api.ProposalData | undefined;
	let driveItemType: Api.DriveItemType | undefined;
	let publicationFormat: Api.PublicationFormat | undefined;

	if (driveItemId) {
		const driveItem = driveList.driveItems[driveItemId];
		driveItemType = driveItem.type;
		proposalStats = driveItem.proposalStats;
		publicationFormat = driveItem.format as Api.PublicationFormat;
		const isDownloaded = DownloadManagerUtils.isItemPersistentlyDownloaded(downloadManager, driveItemId);

		if (isDownloaded) {
			const downloadedItem = downloadManager.items[driveItemId];
			isUpToDate = DownloadManagerUtils.isLatestVersion(driveItem.version, downloadedItem.version);
			isUpdatable = !isUpToDate;
		}
	}

	return {
		driveItemType,
		isUpToDate,
		isUpdatable,
		proposalStats,
		publicationFormat,
	};
};

export default connect(mapStateToProps)(ListItemInfos);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ListItem/Infos/index.tsx